import React from "react";

import { observer } from "mobx-react-lite";
import { ReactComponent as AttentionIcon } from "../../../../../assets/icons/attention.svg";
import { FeedbackOnlyText } from "../../../../../components/FeedbackOnlyText";
import { useNavigateCustom } from "../../../../../hooks";

const feedbackText = {
	title: "Algo deu errado por aqui",
	description: "A página que você procura não existe",
	type: "error404",
	link: {},
	warnings: [],
	button: {
		primaryButtonText: "Ir pro início",
		secondaryButtonText: "",
	},
};

interface IProps {
	children?: JSX.Element;
	isTextUnderIcon?: boolean;
}

export const NotFoundFeedback: React.FC<IProps> = observer((props) => {
	const { children, isTextUnderIcon } = props;
	const navigate = useNavigateCustom();

	return (
		<FeedbackOnlyText
			styleProps={{marginTop: "50px"}}
			isTextUnderIcon={isTextUnderIcon}
			data={feedbackText}
			primaryButton={{
				title: feedbackText.button.primaryButtonText,
				onClick: () => navigate("/", { replace: true }),
			}}
			icon={{
				icon: AttentionIcon,
				w: 58,
				color: "error",
			}}
		>
			{children}
		</FeedbackOnlyText>
	);
});
